import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Type } from '../../app/StyleGuide';
import { CurriculumImage } from '../../components/CurriculumImage';
import { InlineList } from '../../components/Layout';
import licenseService from '../../services/licenseService';
import { LicenseWithCurriculum } from './hooks/useFetchSubscriptions';
import formatDate from './utils/formatDate';

const Container = styled.div`
  align-content: center;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: min-content 1fr;
  }
`;

const Details = styled.div`
  align-content: center;

  h4,
  p {
    margin: 0;
    padding: 0;
  }

  p,
  ul li {
    color: ${Type.Color.medium};
  }
`;

const LicenseDetails = ({
  license,
  showAdditionalDetails,
  hasUpcomingSubscription,
}: {
  license: LicenseWithCurriculum;
  showAdditionalDetails: boolean;
  hasUpcomingSubscription?: boolean;
}) => {
  const renewalDate = license.subscription?.nextRenewalDate ?? license.curriculum?.subscription?.nextRenewalDate;

  return (
    <Container className="grid-container grid-gap-24">
      <CurriculumImage brandCode={license?.curriculum?.brand?.code} />
      <Details className="grid-container grid-row-gap-8">
        <h4 data-qa-hook="itemName">{license.subscription?.item?.title || license.name}</h4>
        <InlineList content="•">
          {license.subscription?.period && <li>{license.subscription.period} Subscription</li>}

          {showAdditionalDetails &&
            !hasUpcomingSubscription &&
            (license.expired === true ? (
              <li>Expired {formatDate(license.endDate)}</li>
            ) : licenseService.isFutureSubscription(license) ? (
              <li>Begins {formatDate(license.startDate)}</li>
            ) : renewalDate && licenseService.isActiveSubscription(license) ? (
              <li>Renews {formatDate(renewalDate)}</li>
            ) : renewalDate && licenseService.isInactiveSubscription(license) ? (
              <li>Expires {formatDate(renewalDate)}</li>
            ) : license.endDate ? (
              <li>Ends {formatDate(license.endDate)}</li>
            ) : (
              <></>
            ))}
        </InlineList>
        {showAdditionalDetails && license.owner && <p>Owned by {license.owner.email}</p>}
      </Details>
    </Container>
  );
};

export default LicenseDetails;
